export default {
    sizes: {
        sm: {
            field: {
                borderRadius: 0,
                color: 'black',
                fontSize: 'xs',
                fontWeight: 'regular',
            },
        },
        md: {
            field: {
                borderRadius: 0,
                color: 'black',
                fontSize: 'sm',
                fontWeight: 'regular',
            },
        },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VsZWN0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vYXBleC1vbmxpbmUvY29tcG9uZW50LWxpYnJhcnkvdGhlbWUvY29tcG9uZW50cy9zZWxlY3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsZUFBZTtJQUNiLEtBQUssRUFBRTtRQUNMLEVBQUUsRUFBRTtZQUNGLEtBQUssRUFBRTtnQkFDTCxZQUFZLEVBQUUsQ0FBQztnQkFDZixLQUFLLEVBQUUsT0FBTztnQkFDZCxRQUFRLEVBQUUsSUFBSTtnQkFDZCxVQUFVLEVBQUUsU0FBUzthQUN0QjtTQUNGO1FBQ0QsRUFBRSxFQUFFO1lBQ0YsS0FBSyxFQUFFO2dCQUNMLFlBQVksRUFBRSxDQUFDO2dCQUNmLEtBQUssRUFBRSxPQUFPO2dCQUNkLFFBQVEsRUFBRSxJQUFJO2dCQUNkLFVBQVUsRUFBRSxTQUFTO2FBQ3RCO1NBQ0Y7S0FDRjtDQUNGLENBQUEiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB7XG4gIHNpemVzOiB7XG4gICAgc206IHtcbiAgICAgIGZpZWxkOiB7XG4gICAgICAgIGJvcmRlclJhZGl1czogMCxcbiAgICAgICAgY29sb3I6ICdibGFjaycsXG4gICAgICAgIGZvbnRTaXplOiAneHMnLFxuICAgICAgICBmb250V2VpZ2h0OiAncmVndWxhcicsXG4gICAgICB9LFxuICAgIH0sXG4gICAgbWQ6IHtcbiAgICAgIGZpZWxkOiB7XG4gICAgICAgIGJvcmRlclJhZGl1czogMCxcbiAgICAgICAgY29sb3I6ICdibGFjaycsXG4gICAgICAgIGZvbnRTaXplOiAnc20nLFxuICAgICAgICBmb250V2VpZ2h0OiAncmVndWxhcicsXG4gICAgICB9LFxuICAgIH0sXG4gIH0sXG59XG4iXX0=